import { useCallback, useEffect, useState } from "react";
import AvatarSelector from "../AvatarSelector";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { User } from "../AuthContext";
import Swal from "sweetalert2";

type ObservatorHandlerProps = {
  roomId: string;
  user: User | null;
}

const ObservatorHandler: React.FC<ObservatorHandlerProps> = ({ roomId, user }) => {
  const [showAvatarModal, setShowAvatarModal] = useState(false);

  useEffect(() => {
    if (!user) return;

    // Lógica para lidar com observadores em uma reunião
    const participantRef = doc(db, "rooms", roomId, "participants", user.uid);

    const unsubscribe = onSnapshot(participantRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const participantData = docSnapshot.data();
        // Se o terapeuta enviou um convite, o campo 'promotionStatus' será 'invited'.
        if (participantData.promotionStatus === "invited") {
          // Mostra o modal de seleção de avatar para o participante.
          setShowAvatarModal(true);
        }
      }
    });

    return () => {
      unsubscribe();
    }
  }, [roomId, user]);

  const handleAvatarSelectionInRoom = useCallback(
    async (
      avatarId: string | null
    ) => {
      if (user && roomId && avatarId) {
        try {
          const participantRef = doc(
            db,
            "rooms",
            roomId,
            "participants",
            user.uid,
          );
          await updateDoc(participantRef, {
            avatarId: avatarId,
            roleInSession: "representative",
            promotionStatus: "accepted",
          });
          setShowAvatarModal(false);
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Erro ao aceitar o convite",
            text: "Ocorreu um erro ao aceitar o convite para representar. Por favor, tente novamente.",
          });
          
          console.error("Erro ao aceitar o convite para representar:", error);
        }
      } else {
        // Se o usuário cancelar, limpa o convite para não mostrar o modal de novo.
        if (user && roomId) {
          await updateDoc(doc(db, "rooms", roomId, "participants", user.uid), {
            promotionStatus: "declined",
          });
        }
        setShowAvatarModal(false);
      }
    },
    [user, roomId],
  );

  if (showAvatarModal) {
    return (
      <AvatarSelector
        onConfirm={handleAvatarSelectionInRoom}
        onClose={() => handleAvatarSelectionInRoom(null)}
        isModal={true}
        forceAvatarSelection={true}
      />
    )
  }

  return null;
}

export default ObservatorHandler;